<sub-filtro-usuarios
    [(filtroUsuario)]="filterUsersSelected"
    [maxSelection]="20"
    [corretoraId]="corretoraId"
></sub-filtro-usuarios>
